/* HCORZ
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/07/2025 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import { ToolsProvider } from "../../context/Tools/ToolsContext";

export const AllToolsProvider = (props) => (
  <ToolsProvider>
    {props.children}
  </ToolsProvider>
);
